'use client'
import { useEffect } from 'react'
import { HiOutlineXMark } from 'react-icons/hi2'
import { ClearButton } from '../ui/clear-button'

export const EmbeddedHeader = () => {
  // Hide the scrollbar when fgpt is embedded
  useEffect(() => {
    const style = document.createElement('style')
    style.innerHTML = `
      /* Chrome, Safari and Opera */
      *::-webkit-scrollbar {
        display: none;
      }
      /* Firefox */
      * {
        scrollbar-width: none;
      }
      /* IE and Edge */
      * {
        -ms-overflow-style: none;
      }
    `
    document.head.appendChild(style)

    return () => {
      document.head.removeChild(style)
    }
  }, [])

  return (
    <div
      className={`sticky top-0 z-10 flex items-center justify-between gap-8 bg-white px-2 pt-1 text-black`}
    >
      <div className="flex flex-1 items-center justify-between gap-8 lg:justify-start">
        <ClearButton
          title="New Chat"
          className="flex items-center gap-2 rounded-full p-2 text-lg"
        />
      </div>

      <button
        onClick={() => {
          window.parent.postMessage('CLOSE_FGPT', '*')
        }}
        className="rounded-full px-2 py-4 text-lg"
      >
        <HiOutlineXMark />
      </button>
    </div>
  )
}

export default EmbeddedHeader
